import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TextControl } from '../InputControls';
import { makeRequest, validateEmail } from '../../utils';

export default function AboutPage() {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  document.title = `About | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `We seek to revive the legacy of Hanuman Books, the legendary and cult series of chapbooks that were printed in southern India and published out of the storied Chelsea Hotel in New York City between 1986 and 1993.`);


  const signup = async () => {
    if (!validateEmail(email)) {
      setSuccess(false);
      setMessage(`Please enter a valid email.`);
      return;
    }
    let data = await makeRequest(`newsletter?email=${email}`);
    if (data.ok) {
      setSuccess(true);
      setMessage(`Thanks! You've successfully signed up!`)
    } else {
      setSuccess(false);
      setMessage(`There was a problem signing you up.`)
    }
  };

  useEffect(() => {
    setMessage('');
  }, [email])

  return (
    <div className='newPageContainer'>
      <div className='mainText'>

        <h1>About</h1>

        <p>Launched in the autumn of 2023, Hanuman Editions is an independent press publishing critical works of avant-garde literature, with an emphasis on translation. Responding to the importance of the compact in contemporary culture, with both physical economy and a capacious regard for language and ideas, the books serve as portals to a new and globally situated vanguard.</p>

        <p>Designed to slip in a pocket or the palm of a hand, the editions are pithy tomes that travel far. The press expands on the peripatetic scope of its predecessor, Hanuman Books, whose publications were printed and handbound at Kalakshetra Press in Chennai, channeling the Hanuman <em>chalisa</em>, miniature prayer books circulated widely across India as talismans for spiritual protection. The volumes’ scale and subjects also evoke the radical example of Menocchio in the late Carlo Ginzburg’s <em>The Cheese and the Worms</em> (1976), where the individual imaginary becomes a harbinger of larger currents.</p>

        <p>The press publishes individual volumes and special edition box sets of contemporary works and select reissues from the Hanuman Books catalogue, as a polyphonic register of fiction, poetry, art and visual culture. The editions traverse languages and forms, from a modern ghost story in South Korean (Bora Chung's <em>Grocery List</em>) to a tale of lifelong limerence translated from Bahasa (Eka Kurniawan’s <em>Love Never Dies</em>); a lyrical interpretation of classical Tamil literature (Vivek Narayanan’s <em>The Kuruntokai and Its Mirror</em>) and an American picaresque (Raymond Pettibon’s illustrated edition, <em>The Frontier Index</em>).</p>

        <p>These are accompanied in each series by reissued writings from underground icons like Eileen Myles, Bob Flanagan, John Ashbery and Cookie Mueller, alongside occasional special edition volumes such as works by influential philosopher-mystic Simone Weil and the visionary poet Henri Michaux, as well as Eileen Myles’ short story, 1969.</p>

        <p>Alighting on these lineages in a portability-focused present, an age of plenty and distraction, Hanuman Editions is primed for a return to objectness. In this spirit, the books serve as secret documents or <em>samizdat</em> of ideas and expressions, for a world as it is now, and may yet become.</p>

        <p>Please sign up for our mailing list below to receive news of upcoming titles and events and follow us on social media: @hanumaneds (Twitter / Instagram).</p>



        {!success &&
          <div className='emailSignup'>
            <TextControl
              value={email}
              change={setEmail}
              placeholder={'Your email'}
            />
            <button className='signup-button' onClick={signup}>Submit</button>
          </div>
        }
        {message && <div className={`emailMessage ${success && 'emailSuccess'}`}>{message}</div>}
      </div>

    </div>
  )
}